import React, { useState } from "react";
import {
  Button,
  CheckBox,
  DatePicker,
  FullScreenLoading,
  WrappedTimeSeriesChart,
} from "src/Components";
import {
  IDailyChartSearchParams,
  RollReport,
} from "src/Interfaces/coveredCall";
import { Graph_Dto } from "src/Interfaces/orderbookGraphInterfaces";
import { packetErrorHandler } from "src/Utils/requestUtils";
import CircularProgress from "@mui/material/CircularProgress";

interface IProps {
  row: RollReport;
  chartGetter: (params: IDailyChartSearchParams) => Promise<Graph_Dto>;
}

const Loading = () => (
  <div className="flex justify-center items-center h-full w-full">
    <CircularProgress />
  </div>
);

const SmallRollDailyChartUI = ({ row, chartGetter }: IProps) => {
  const [loading, setLoading] = React.useState(false);
  const [fromDate, setFromDate] = React.useState(
    getDateFromToday(90).toISOString(),
  );
  const [toDate, setToDate] = React.useState(new Date().toISOString());
  const [excludeNonTradingDays, setExcludeNonTradingDays] =
    React.useState(true);
  const [graphData, setGraphData] = useState({} as Graph_Dto);

  React.useEffect(() => {
    fetchGraph(fromDate, toDate);
  }, []);

  const fetchGraph = (from: string, to: string) => {
    setLoading(true);
    const data: IDailyChartSearchParams = {
      fromDate: from,
      toDate: to,
      key: row.key,
      excludeNonTradingDays,
    };

    chartGetter(data)
      .then((resp) => setGraphData(resp))
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  };

  const handleFromDate = (_: string, value: any) => {
    setFromDate(value);
  };

  const handleToDate = (_: string, value: any) => {
    setToDate(value);
  };

  const onSubmit = () => {
    fetchGraph(fromDate, toDate);
  };

  function getDateFromToday(dayCount: number) {
    const targetDate = new Date();
    targetDate.setDate(new Date().getDate() - dayCount);
    return targetDate;
  }

  const setDateFromBtns = (dayCount: number) => {
    const today = new Date();
    const targetDate = getDateFromToday(dayCount);
    const nextFromDate = targetDate.toISOString();
    const nextToDate = today.toISOString();
    setFromDate(nextFromDate);
    setToDate(nextToDate);
  };

  const getDateSetterBtn = (dayCount: number) => (
    <Button
      text={`${dayCount} روز`}
      onClick={() => setDateFromBtns(dayCount)}
      variant={
        fromDate?.split("T")[0] ===
        getDateFromToday(dayCount).toISOString()?.split("T")[0]
          ? "contained"
          : "outlined"
      }
    />
  );

  return (
    <div className="flex gap-3 h-full w-full min-h-0">
      <div className="flex flex-col w-52 shrink-0 justify-start items-start gap-3 top-14">
        <DatePicker
          label="از تاریخ"
          name="fromDate"
          onChange={handleFromDate}
          value={fromDate}
        />
        <DatePicker
          label="تا تاریخ"
          name="toDate"
          onChange={handleToDate}
          value={toDate}
        />

        <div className="flex flex-row justify-center items-center gap-1 w-full">
          {getDateSetterBtn(7)}
          {getDateSetterBtn(30)}
          {getDateSetterBtn(90)}
        </div>
        <CheckBox
          checked={excludeNonTradingDays}
          label="حذف روزهای تعطیل"
          name="excludeNonTradingDays"
          onChange={(_, value) => setExcludeNonTradingDays(value)}
        />
        <Button text="جستجو" onClick={onSubmit} variant="contained" />
      </div>
      <div className="h-full w-full flex-1 min-w-0 min-h-0">
        {loading ? (
          <Loading />
        ) : (
          <WrappedTimeSeriesChart
            dataset={[graphData]}
            withDate
            YValueType="priceWithDecimal"
            decimalPlaces={2}
            className="h-full w-full"
          />
        )}
      </div>
    </div>
  );
};

export default SmallRollDailyChartUI;
